// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import DeviceDetails from './DeviceDetails';

import { IRoute } from '../';

export const SERIAL_NUMBER = '{serialNumber}';

const deviceDetailsRoutes: IRoute[] = [
    {
        crumbText: SERIAL_NUMBER,
        component: DeviceDetails,
        exact: true,
        path: '/device',
    },
];

export default deviceDetailsRoutes;
